//BACKOFFICE
export const BACKOFFICE = 1000;

//POS
export const POS = 2000;
export const POS_ZREPORT = 2001;
export const POS_XREPORT = 2002;
export const POS_RETOUR = 2003;
export const POS_CANCELLINE = 2004;
export const POS_CANCELRECEIPT = 2005;
export const POS_DRAWER = 2006;
export const POS_UNBLOCK = 2007;
export const POS_EXCEED_NEGATIVE_SALDO = 2008;



// WEBPACK FOOTER //
// src/constants/Rights.js